import styled from "styled-components";

export const ProductsWrapper = styled.div``;

export const AddProductWrapper = styled.div`
  .separation-border {
    border-bottom: 1px solid var(--border);
  }
  .optionsContent {
    margin-left: 50px;
  }
  .typeRadioBtnWrapper {
    margin-top: 50px;
    /* border-bottom: 1px solid var(--borderLight); */
    padding-bottom: 30px;
  }
  .date-label {
    font-size: 14px;
    margin-right: 8px;
    color: var(--text);
    margin-left: 20px;
    width: 152px;
    @media (max-width: 768px) {
      margin-left: 0;
    }
  }
`;
